import React from 'react';

function AdMobBanner(): React.JSX.Element | null {
  return null;
}

export default AdMobBanner;
